// Obtener el valor de shopDomain
let shopDomain = "";
if (typeof orbito !== "undefined" && typeof orbito.getCountryDomain === "function") {
  shopDomain = orbito.getCountryDomain();
} else {
  shopDomain = document.domain;
}

if (!customElements.get("m-localization-form")) {
    class t extends HTMLElement {
        constructor() {
            super();
            const selectElement = this.querySelector("[data-localization-select]");
            if (selectElement) {
                selectElement.addEventListener("change", (e) => {
                    const value = e.target.value;
                    const form = selectElement.closest("[data-localization-form]");
                    const inputElement = form.querySelector("input[data-localization-input]");
                    const name = inputElement.getAttribute("name");

                    // Actualizar la cookie dependiendo del nombre del valor
                    let cookieName = "";
                    if (name === "country_code") {
                        cookieName = "mdApp_countryCodeDomain";
                    } else if (name === "locale_code") {
                        cookieName = "mdApp_showRecommendationLang";
                    }

                    // Si se encontró el nombre de la cookie, actualizar la cookie
                    if (cookieName) {
                        document.cookie = `${cookieName}=${value}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60};`;
                    }

                    // Actualizar el valor del atributo "value" del input
                    if (inputElement) {
                        inputElement.setAttribute("value", value);
                    }

                    // Enviar el formulario
                    if (form) {
                        form.submit();
                    }
                });
            }
        }
    }
    customElements.define("m-localization-form", t);
}